import React, { useContext, useState } from 'react';
import { useMutation } from '@apollo/client';
import {
  UPDATE_AI_FEATURE,
  ONBOARD_AI_AGENT
} from '@nile/banyan/src/Graphql/Mutations/ai';
import { AccountClient } from '@nile/graphql';
import AIFeaturesHook from '@nile/components/src/Utils/aiFeaturesHook';
import TriageConfiguration from './TriageConfiguration';
import { AIOnboardingHook } from '@nile/components/src/Components/AI/hooks/AIOnboardingHook';
import { AIContext, EventEmitter } from '@nile/components';
import { TextStyle } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';

const TriageConfigurationOnboarding = (props) => {
  const aiFeatureHook = AIFeaturesHook();
  const aiOnboardingHook = AIOnboardingHook();
  const aiContext = useContext(AIContext);
  const [showMessage, setShowMessage] = useState(false);

  const [onboardAIAgentMutation] = useMutation(ONBOARD_AI_AGENT, {
    client: AccountClient,
    onCompleted: () => {
      // AI Agent onboarding completed
    },
    onError: (error) => {
      console.error('Error onboarding AI agent:', error);
    }
  });

  const onUpdate = async (variables) => {
    const onboardResponse = await onboardAIAgentMutation({
      variables: {
        input: {
          aiAgent: variables.input
        }
      }
    });

    await aiFeatureHook.getAIFeaturesData();

    const count = onboardResponse?.data?.onboardAIAgent?.count;
    const triageFeatureData = aiFeatureHook?.getAIFeatureData('TICKET_TRIAGE');
    const isAgentActive = triageFeatureData?.state === 'ACTIVE';

    if (count && isAgentActive) {
      aiOnboardingHook?.completeOnboarding();
      aiContext?.setShowOnboarding(false);
    } else {
      setShowMessage(true);
    }
    EventEmitter.dispatch('refreshTriageTickets');
    return onboardResponse;
  };

  if (showMessage) {
    return (
      <div className="ai-dark-bg p10 br10">
        <TextStyle>
          <FormattedMessage id="ai.onboarding.triage.ticket.waiting.message" />
        </TextStyle>
      </div>
    );
  }

  return <TriageConfiguration isOnboarding onUpdate={onUpdate} />;
};

export default TriageConfigurationOnboarding;
